import { HStack, Text } from '@genial/components';
import { Checkbox } from 'native-base';
import React from 'react';
import { useRecoilState } from 'recoil';

import { orderItemState } from '../../../../store/order/atom';

export const ValueAdjustedCheck: React.FC = () => {
  const [orderItem, setOrderItem] = useRecoilState(orderItemState);

  const handleChange = (value: boolean) => {
    setOrderItem((prev) => ({
      ...prev,
      acceptedTermForValueAdjusted: value,
    }));
  };

  if (!orderItem.valueAdjustedDueSuitability) {
    return null;
  }

  return (
    <HStack alignItems="center" flex={1} space="stack.nano">
      <Checkbox
        onChange={handleChange}
        value="1"
        isChecked={orderItem.acceptedTermForValueAdjusted}
        _checked={{
          borderColor: 'brand.primary.principal',
          backgroundColor: 'brand.primary.principal',
        }}
        _hover={{ borderColor: 'brand.primary.principal' }}
      />
      <Text flex={1}>
        Declaro que o valor da ordem foi alterado devido ao desenquadramento em relação ao perfil de
        risco da carteira do cliente.
      </Text>
    </HStack>
  );
};
